import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function TUTC
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            userConfiguration={true}
        />
    );
}
export default TUTC